module.exports = __webpack_public_path__ + "static/img/cus-bg-kaka.60ef6ace.png";